import { Text, Container, Flex, Image, Box } from "@mantine/core";
import logoImage from "../../assets/logo/logo-full.svg";
import icon_instagram from "../../assets/icon/social/icon_social_IG.svg";
import icon_threads from "../../assets/icon/social/icon_social_threads.svg";
import { useMatches } from "@mantine/core";

export const Footer = () => {
	const width = useMatches({
		base: "calc(100% - 3rem)",
		sm: "csm",
	});

	const textSize = useMatches({
		base: "md",
		sm: "xl",
	});

	return (
		<Container c={"gray.9"}>
			<Flex
				w={width}
				justify="space-between"
				align="start"
				pt={"40"}
				pb={"40"}
				direction={{ base: "column", sm: "row" }} // Stack vertically on mobile
				gap={{ base: "2rem", sm: "0" }} // Add gap between columns on mobile
			>
				{/* Left Column - Logo and Copyright */}
				<Flex direction="column" align="start" justify="start" gap={16}>
					<Box>
						<Image
							src={logoImage}
							h={{ base: "24px", md: "24px" }}
							mb={".5rem"}
							w={"auto"}
							fit="contain"
						/>
					</Box>
					<Box>
						<Text size={textSize}>
							© {new Date().getFullYear()} My Threads Insight. All rights
							reserved.
						</Text>
						<Text size={textSize}>
							Created by{" "}
							<a
								href="https://dddesign.io"
								target="_blank"
								rel="noopener noreferrer"
							>
								<strong
									style={{ fontWeight: 800, textDecoration: "underline" }}
								>
									Data Driven Design
								</strong>
							</a>
						</Text>
					</Box>
				</Flex>

				{/* Right Column - Social Links */}
				<Flex direction="column" gap={32}>
					<Text size="xl" fw={800} lh={1}>
						Social
					</Text>
					<Flex align="center" gap={24}>
						<a
							href="https://instagram.com"
							target="_blank"
							rel="noopener noreferrer"
						>
							<Image src={icon_instagram} h={32} w="auto" />
						</a>
						<a
							href="https://threads.net"
							target="_blank"
							rel="noopener noreferrer"
						>
							<Image src={icon_threads} h={32} w="auto" />
						</a>
					</Flex>
				</Flex>
			</Flex>
		</Container>
	);
};
